// Layout.js
import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import TopBar from "./topbar";
import SideBar from "./sidebar";
import "./layout.css";
import Footer from "./footer";
import SideBarPm from "./sidebarpm";
import SideBarWP from "./sidebarwp";

const Layout = () => {
  const [user, setUser] = useState("");

  useEffect(() => {
    const user = localStorage.getItem("state");
    const userI = JSON.parse(user);
    setUser(userI?.user);
  }, []);
  return (
    <div className="main" style={{ background: "rgb(247, 248, 249)" }}>
      <div className="d-flex">
        <div style={{ width: 240, alignItems: "center" }}>
          {user.user_id == "1" ? (
            <SideBarPm />
          ) : user.user_id == "2" ? (
            <SideBar />
          ) : (
            <SideBarWP />
          )}
        </div>
        <div className="w-100">
          <TopBar />
          <div
            className="outlet-container"
            style={{ height: 615, overflow: "scroll", background: "#f5f6fa" }}
          >
            <Outlet />
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Layout;
